module.exports = __webpack_public_path__ + "assets/media/office365.d7eed25b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/office365.svg
// module id = 885
// module chunks = 0